/* eslint-disable jsx-a11y/label-has-associated-control */
import { Checkbox } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import Image from 'components/Image';

type ContainerProps = {
    $isVoted: boolean;
    $showCorrectAnswer: boolean;
    $showResult: boolean;
    $rate?: number;
    $isBestAnswer: boolean;
};

const shouldShowResult = ($isVoted: boolean, $showResult: boolean) => {
    return $isVoted && $showResult;
};
const shouldShowCorrectAnswer = ($showCorrectAnswer: boolean, $isBestAnswer: boolean) => {
    return $showCorrectAnswer && $isBestAnswer;
};

const CheckboxStyled = styled(Checkbox)`
    .ant-checkbox {
        display: none;
    }
`;

const Container = styled.div<ContainerProps>`
    ${({ $isVoted, $rate, $showCorrectAnswer, $showResult, $isBestAnswer }) =>
        (shouldShowResult($isVoted, $showResult) ||
            shouldShowCorrectAnswer($showCorrectAnswer, $isBestAnswer)) &&
        `background: ${getCardBackgroundColor($rate)}`};
    width: 100%;
    padding: 15px;
    :hover {
        cursor: pointer;
        ${({ $isVoted, theme }) => !$isVoted && `background: ${theme.colors.greyishBrown}`};
    }
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
`;

const getCardBackgroundColor = (rate: number) => {
    switch (rate) {
        case 0:
            return 'red';
        case 1:
            return 'green';
        default:
            return 'grey';
    }
};

type Props = {
    $item: ContestQuestion;
    $isLocked?: boolean;
    $showCorrectAnswer?: boolean;
    $showResult?: boolean;
    $canUnVote?: boolean;
    $isBestAnswer?: boolean;
    onVote: () => void;
    onUnVote?: () => void;
};

export const ImageItem = ({
    $item,
    $isLocked = false,
    onVote,
    onUnVote,
    $isBestAnswer,
    $showCorrectAnswer = false,
    $canUnVote = true,
    $showResult = false
}: Props) => {
    const [checked, setChecked] = useState<boolean>(false);

    const isDisabled = $isLocked && $canUnVote ? false : $isLocked;
    const handleClick = () => {
        if (isDisabled) return;
        setChecked((prev) => {
            return !prev;
        });
        if (checked) {
            onUnVote();
            return;
        }
        onVote();
    };

    return (
        <CheckboxStyled checked={checked} value={$item.slug}>
            <Container
                $isVoted={checked}
                $showCorrectAnswer={$showCorrectAnswer}
                $rate={$item.rating}
                $showResult={$showResult}
                $isBestAnswer={$isBestAnswer}
            >
                <Image
                    src={$item.image}
                    onClick={handleClick}
                    width={$item?.imageInfo.width || 500}
                    height={$item?.imageInfo.height || 800}
                    alt={$item.title}
                />
            </Container>
        </CheckboxStyled>
    );
};

export default ImageItem;
